export const apiUrl = process.env.REACT_APP_API_URL;
export const tokenUrl = process.env.REACT_APP_TOKEN_URL;
export const chatApiUrl = process.env.REACT_APP_CHAT_API_URL;
export const MedicinesUrl = '/medicines';
export const InteractionsUrl = '/interactions';
export const CreateNewAccountUrl = '/create-new-account';
export const NewPasswordUrl = '/new-password';
export const sendRegistrationConfirmEmail = true;
export const applicationServerPublicKey = 'BNib7rKZgicU_HCETJYAsrhhI1PKCzSTV1Mu6bc75ynLs4P8ZSVvAeLGHdrqHvH5SeaozqCVJdECrtOZp6w1xoY';
export const DiseaseUrl = '/diseases';
export const DisposalPlaces = '/disposal-places';
export const PrescriptionUrl = '/user/prescriptions';
export const MaxFileUploadSize = 5242880; // 5 MB
export const MaxLabResultFileSize = process.env.REACT_APP_MAX_LAB_RESULT_FILE_SIZE;
export const SnoozeMinutes = 10;
export const BdaUrl = 'https://www.bda.bg/bg/регистри/листовки-за-пациента';

/* Theme constants */
import { createMuiTheme } from '@material-ui/core';
import blue from '@material-ui/core/colors/blue';

export const TabStyles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  tabsRoot: {
    borderBottom: '1px solid #ccc',
    marginBottom: '10px',
    backgroundColor: '#f5f5f5'
  },
  tabsIndicator: {
    backgroundColor: '#1890ff',
  },
  tabRoot: {
    // textTransform: 'initial',
    minWidth: 72,
    fontWeight: 500,
    marginRight: theme.spacing(2),
    color: '#444',
    // fontFamily: [
    //   '-apple-system',
    //   'BlinkMacSystemFont',
    //   '"Segoe UI"',
    //   'Roboto',
    //   '"Helvetica Neue"',
    //   'Arial',
    //   'sans-serif',
    //   '"Apple Color Emoji"',
    //   '"Segoe UI Emoji"',
    //   '"Segoe UI Symbol"',
    // ].join(','),
    '&:hover': {
      color: '#40a9ff',
      opacity: 1,
    },
    '&$tabSelected': {
      color: '#1890ff',
      fontWeight: 500,
    },
    '&:focus': {
      color: '#40a9ff',
    },
  },
  tabSelected: {},
  typography: {
    padding: theme.spacing(3),
  },
});

export const dataPickerWithChekbox = createMuiTheme({
  overrides: {
    MuiFormControl: {
      root: {
        width: '80%'
      },
      marginNormal: {
        marginTop: 5,
        marginBottom: 0,
        paddingLeft: '10px'
      },
    },
    MuiIconButton: {
      root: {
        padding: '10px 0 0 0 !important'
      }
    },

  },
  palette: {
    primary: blue
  },
});

export const smallButtonForAdd = createMuiTheme({
  overrides: {
    MuiButton: {
      contained: {
        padding: '7px 7px 7px 11px',
        width: '32px',
        color: 'white'
      },
      containedSecondary: {
        color: 'white'
      },
      root: {
        minWidth: '32px',
        minHeight: '32px'
      }
    }
  },
  palette: {
    secondary: { main: '#35a436' },
    primary: { main: 'rgb(233, 18, 36)' }
  },
});


export const buttonBadge = createMuiTheme({
  overrides: {
    MuiBadge: {
      badge: { top: -5, right: -5 }
    }
  },

});

export const buttonSmallBadge = createMuiTheme({
  overrides: {
    MuiBadge: {
      badge: {
        top: 0,
        right: -1,
        height: '15px',
        minWidth: '15px',
        fontSize: '0.65rem'
      }
    }
  },
});

export const buttonBadgeMaterialIcon = createMuiTheme({
  overrides: {
    MuiBadge: {
      badge: { right: -2 }
    }
  },

});

export const fullWidthDialog = createMuiTheme({
  overrides: {
    MuiDialog: {
      paper: {
        margin: 0,
        maxWidth: '100%'
      }
    }
  },
  palette: {
    primary: blue
  }
});

export const snackbar = createMuiTheme({
  overrides: {
    MuiSnackbarContent: {
      root: {
        width: '90%',
        alignItems: 'start'
      },
      action: {
        paddingTop: 5,
        paddingLeft: 0,
        display: 'flow-root'
      },
      message: {
        width: '90%'
      }
    },
    MuiSnackbar: {
      root: {
        alignItems: "start"
      }
    },
    MuiIconButton: {
      root: {
        padding: 0
      }
    }

  }
});

export const notificationDrawer = createMuiTheme({
  overrides: {
    MuiDrawer: {
      paperAnchorTop: {
        maxHeight: '40%'
      }
    }
  },
  palette: {
    primary: blue
  }
});

export const inputWithButton = {
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  },
  input: {
    marginLeft: 8,
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    width: 1,
    height: 28,
    margin: 4,
  },
};

export const chatDialogTheme = createMuiTheme({
  overrides: {
    MuiFormControl: {
      marginNormal: {
        marginTop: 5,
        marginBottom: 0,
        width: '100%'
      },
      root: {
        width: '100%'
      }
    },
    MuiDialog: {
      root: {
        pointerEvents: 'none'
      },
      paper: {
        margin: '0 20px 130px 0',
        minWidth: '335px'
      },
      scrollPaper: {
        alignItems: 'flex-end',
        justifyContent: 'flex-end'
      }
    },
    MuiIconButton: {
      root: {
        padding: 0
      }
    },
    MuiPaper: {
      root: {
        pointerEvents: 'auto'
      }
    }
  },
  palette: {
    primary: blue,
  },
});

export const smallDialogTheme = createMuiTheme({
  overrides: {
    MuiFormControl: {
      marginNormal: {
        marginTop: 5,
        marginBottom: 0,
        width: '100%'
      },
      root: {
        width: '100%'
      }
    },
    MuiDialog: {
      paper: {
        margin: 0,
        maxWidth: '50% !important',
        minWidth: '335px'
      }
    },
    MuiIconButton: {
      root: {
        padding: 0
      }
    },
  },
  palette: {
    primary: blue
  },
});

export const paginatoorButtons = createMuiTheme({
  overrides: {
    MuiButton: {
      sizeSmall: {
        minWidth: 40,
        minHeight: 30
      },
      contained: {
        boxShadow: 'unset'
      }
    }
  },
  palette: {
    primary: blue
  },
});

export const chartsButtonTheme = createMuiTheme({
  overrides: {
    MuiButton: {
      root: {
        minWidth: 50
      }
    }
  },
  palette: {
    primary: blue
  }
})

export const device = {
  desktop: 1025,
  tablet: 768,
  phone: 500
}